import { CaseData } from '../types/case';

/**
 * Deep merges formData with caseData, giving precedence to formData (unsaved changes)
 * This ensures that components see the latest values including unsaved changes
 * 
 * @param caseData - Saved case data from server
 * @param formData - Working copy with unsaved changes
 * @returns Merged case data
 */
export function mergeCaseData(caseData: CaseData | null | undefined, formData: any): CaseData | null {
    if (!caseData) {
        return formData || null;
    }

    if (!formData) {
        return caseData;
    }

    // Deep merge function
    const deepMerge = (base: any, updates: any): any => {
        if (updates === null || updates === undefined) {
            return base;
        }

        if (Array.isArray(updates)) {
            return updates; // Arrays are replaced entirely
        }

        if (typeof updates !== 'object' || updates instanceof Date) {
            return updates !== undefined ? updates : base;
        }

        if (typeof base !== 'object' || base === null || Array.isArray(base)) {
            return updates;
        }

        const merged = { ...base };

        for (const key in updates) {
            if (updates.hasOwnProperty(key)) {
                merged[key] = deepMerge(base[key], updates[key]);
            }
        }

        return merged;
    };

    return deepMerge(caseData, formData) as CaseData;
}

